// extracted by mini-css-extract-plugin
export default {"box__container":"BoxEditor_box__container__2hF6L"};